import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TitleManagerService {
  public readonly title = signal('Title');
  public readonly show = signal(true);
  public readonly backTo = signal<string | null | ((authenticated: boolean) => string)>('');
}
